import {
  ArrowLeftOutlined,
  ProductOutlined,
  PullRequestOutlined,
  SafetyCertificateOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Col, Layout, Menu, Row, Typography } from "antd";
import { useRef, useState } from "react";
import ShoppingInfos from "./ShoppingInfos";
import TaxCertificate from "./TaxCertificate";
import { useNavigate, useSearchParams } from "react-router-dom";
import VerifyInfoes from "apps/Account/Pages/Institutional/Components/VerifyInfoes";
import CorporateInfoes from "apps/Account/Pages/Institutional/Components/CorporateInfoes";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import endPoints from "../../EndPoints"
import { useQueryClient } from "react-query";
import { handleSetinstitutionalStoreInfoes } from "apps/Account/Pages/Institutional/ClientSideStates";
import ResponsiveMenu from "apps/Common/ResponsiveMenu";

const AddOrUpdateStore = () => {
  const [currentStep, setCurrentStep] = useState(0); // Start with step 1
  const { Sider, Content } = Layout;
  const { Text } = Typography;
  const containerRef = useRef(null)
  const queryClient = useQueryClient()
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const storeId = searchParams.get("storeId");
  const dispatch = useDispatch()
  const { initialStoreInfoes } = useSelector(
    (state: RootState) => state.institutional
  );

  const items = [

    {
      key: 0,
      label: "Doğrulama",
      icon: <SearchOutlined />,

    },
    { key: 1, label: "Mağaza Bilgileri", icon: <ProductOutlined />, disabled: storeId || initialStoreInfoes?.isletmeUnvani ? false : true, },
    {
      key: 2,
      label: "İşletme Bilgileri",
      icon: <PullRequestOutlined />,
      disabled: storeId ? false : true,
    },
    {
      key: 3,
      label: "Vergi Levhası",
      icon: <SafetyCertificateOutlined />,
      disabled: storeId ? false : true,
    },
  ];

  return (
    <Col span={24} className="mt-5 ">
      <span
        className="!flex gap-1 items-center !mb-4 !border !rounded-md hover:cursor-pointer !border-gray-200 !w-[130px] !p-2 !ml-1 "
        onClick={() => {
          dispatch(
            handleSetinstitutionalStoreInfoes({ data: null })
          );
          queryClient.resetQueries({
            queryKey: endPoints.getStoreListFilter,
            exact: false,
          });
          navigate("/admin/panel?activePanelMenu=shoppingCenter")
        }
        }

      >
        <ArrowLeftOutlined className="!text-indigo-500 " />
        <Text className="!text-indigo-500" >Geriye Dön</Text>
      </span>
      <Row gutter={[20, 20]} className="xl:!h-screen !bg-white" ref={containerRef}  >
        <Col xs={24} xl={6} xxl={4} className="!rounded-lg ">

          <ResponsiveMenu

            containerRef={containerRef}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            defaultSelectedKeys={["0"]}
            menuItems={items}
            onClick={({ key }) => setCurrentStep(Number(key))}
          />



        </Col>
        <Col xs={24} xl={18} xxl={20} className="  ">
          <Content className="!bg-white ">
            {(() => {
              switch (currentStep) {
                case 0:
                  return <VerifyInfoes setCurrentStep={setCurrentStep} />;
                case 1:
                  return <ShoppingInfos setCurrentStep={setCurrentStep} />;

                case 2:
                  return (
                    <CorporateInfoes
                      setCurrentStep={setCurrentStep}
                      type="panelStore"
                    />
                  );
                case 3:
                  return <TaxCertificate setCurrentStep={setCurrentStep} />;
                default:
                  return <Text>Lütfen bir adım seçin.</Text>; // Fallback for invalid steps
              }
            })()}
          </Content>
        </Col>
      </Row>

    </Col>
  );
};

export default AddOrUpdateStore;
